<template>
  <div class="flex">
    <div class="container">
      <!-- 内容 -->
      <div class="top_cl">充值信息</div>
      <div class="b1">轉數快(F P S)</div>
      <el-table :data="tableData" class="el-table-page custom-table-border"   > <!--:row-style="{ height: '40px' }" :cell-style="{ padding: '0px' }"-->
        <el-table-column prop="key"  width="120" label="訂單已建立"></el-table-column>
        <el-table-column prop="val"  width="180">
          <template slot-scope="scope">
            {{ scope.row.val }}
            <el-tooltip class="item" effect="dark"  v-if = scope.row.icon   placement="top" content="点击复制" :enterable="false" :manual="true">
              <el-button
                  type="text"
                  size="small"
                  @click="copyText(scope.row.val)"
                  icon="el-icon-document-copy"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <div class="b3">
        <div>
          溫馨提示 :
        </div>
        <p> 轉帳輸入正確小數點系統即時完成上分 </p>
        <p> 5分鐘未上分請聯絡客服協助 </p>
      </div>

    </div>

    <div v-if="success" class="ts">充值成功!</div>
    <!--div>
      Window Width: {{ windowWidth }}
    </div-->
  </div>
</template>

<script>

import axios from "axios";

export default {
  // 你的组件选项...
  name : 'payPageGame88',
  data(){
    return{
      timer: null,
      counter: 0,
      success : false,
      //https://86688abc123688.co/payPage?account_name=bbbaaa888&bank_name=TAP%26GO&card_name=LEUNG%20S***%20H**&bank_no=55097494&amount=100.96&order_no=11701038493
      tableData : [
        {
          "key": "用戶賬號:",
          "val": "",
          "icon":  false
        },
        {
          "key": "充值銀行:",
          "val": "",
          "icon": false
        },
        {
          "key": "收款賬號名:",
          "val":  "",
          "icon": true
        },
        {
          "key": "收款卡號:",
          "val":  "",
          "icon": true
        },
        {
          "key": "充值金額:",
          "val": "",
          "icon": true
        },
        {
          "key": "訂單號:",
          "val": "",
          "icon": true
        },

      ],
    }
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    this.tableData[0].val = params.get('account_name');
    this.tableData[1].val = params.get('bank_name');
    this.tableData[2].val = params.get('card_name');
    this.tableData[3].val = params.get('bank_no');
    this.tableData[4].val = params.get('amount');
    this.tableData[5].val = params.get('order_no');
    //this.fetchUserData();
    //this.startTimer();
    setTimeout(this.startTimer,30000)
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.fetchUserData();
        this.counter += 1;
        if(this.counter >= 60)
          this.clearTimer();
      }, 3000); // 每秒增加
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    fetchUserData() {
      const params = new URLSearchParams(window.location.search);
      if(params.get('order_no') != null){
        axios.get('https://86688abc123688.co/getPayStatus?order_no='+params.get('order_no'))
            .then(response => {
              if(response.data.msg == '1' || response.data.msg == '3'){
                this.success = true;
                this.clearTimer();
              }
            })
            .catch(error => {
              console.error('There was an error!', error);
            });
      }
    },
    copyText(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('复制成功');
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    renderHeader(h, { column }) {
      return h('span', [
        column.label,
        h('i', { class: 'el-icon-time' }) // 这里可以根据icon的值来动态切换类名
      ]);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.clearTimer();
  },
};
</script>

<style scoped>

@media only screen and (min-device-width: 768px) {
  .flex{
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 0px;
  }
  .container {
    /* PC端自适应 */
    width: 50%;
    /* 其他样式 */
    min-width: 450px;
    border-color: coral;

    max-width: 600px; /* 设置div的最大宽度 */
    /*background-color: red;  背景色用于可视化留白区域 */
    padding: 10px; /* 内边距 */
    box-sizing: border-box; /* 防止宽度计算错误 */
  }
  .el-table-page {
    width: 325px;
    left: 10%;
  }

  .tableCss{
    width: 305px;
    left: 10%;
  }

  .top_cl{
    background-color: peru;
    color:white;
    width: 95%;
    height: 50px;
    display: flex;
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中，如需要 */
    font-weight: bold;
  }

  .b1{
    font-weight: bolder;padding-top: 15px;font-size: 24px;text-align: center
  }

  .b2{
    font-weight: bolder;padding-top: 15px; font-size: 18px; text-align: left
  }

  .b3
  {
    top : 10px;
    height: 110px;width: 95%;text-align: center;padding-top: -6px;background-color:peru ;
    font-weight: bolder;color: white;
  }

  .ts{
    position:absolute;
    z-index: 99999;
    height: 150px;
    width: 200px;
    background-color: cornflowerblue;
    top: 160px;
    border-radius: 10px; /* 设置圆角的半径大小 */
    color:lavenderblush;
    font-weight: bold;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .custom-table-border {
    border: 1px solid #d3dce6; /* 设置表格边框颜色 */
    /*border-collapse: collapse;  边框合并 */
    border-radius: 10px; /* 设置圆角的半径大小 */
  }

  .custom-table-border th,
  .custom-table-border td {
    border: 1px solid #d3dce6; /* 设置单元格边框颜色 */
  }

}



@media only screen and (max-device-width: 768px) {
  .flex{
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 10px;
  }
  /* 在屏幕宽度小于或等于768像素时应用以下样式 */
  .container {
    /* 手机端全屏 */
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 20px;
    left: 10px;
    z-index: 100; /* 确保div在其他内容之上 */
    border-color: coral;
    /* 其他样式 */
  }



  .top_cl{color: cornflowerblue}
  .el-table-page {
    width: 305px;
    left: 9%;
  }


  .top_cl{
    background-color: peru;
    color:white;
    width: 95%;
    height: 50px;
    display: flex;
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中，如需要 */
    font-weight: bold;
  }

  .b1{
    font-weight: bolder;padding-top: 15px;font-size: 24px;text-align: center
  }

  .b2{
    font-weight: bolder;padding-top: 15px; font-size: 18px; text-align: left
  }

  .b3
  {
    height: 110px;width: 95%;text-align: center;padding-top: -6px;background-color: peru;
    font-weight: bolder;color: white;top:15px;
  }

  .ts{
    position:absolute;
    z-index: 99999;
    height: 150px;
    width: 200px;
    background-color: cornflowerblue;
    top: 160px;
    border-radius: 10px; /* 设置圆角的半径大小 */
    color:lavenderblush;
    font-weight: bold;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

  }

  .custom-table-border {
    border: 1px solid #d3dce6; /* 设置表格边框颜色 */
    /*border-collapse: collapse;  边框合并 */
    border-radius: 10px; /* 设置圆角的半径大小 */
  }

  .custom-table-border th,
  .custom-table-border td {
    border: 1px solid #d3dce6; /* 设置单元格边框颜色 */
  }
}



</style>